import { useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import {useTranslation} from "react-i18next";
import service from "../services/jwtAuthService";

const AxiosErrorInterceptor = () => { // Pass pathname as a prop
    const TRES_SEGUNDOS = 3000;
    const {t} = useTranslation()

    useEffect(() => {
        const axiosResponseInterceptor = axios.interceptors.response.use(
            (response) => response,
            (error) => {
                let message = 'An error occurred. Please try again.';
                let forceLogout = false

                if (error.response) {
                    if (error.response.status === 401 && window.location.pathname === '/sessions/signin') {
                        message = t('Usuário ou Senha inválido');
                    }else if (error.response.status === 401 ||
                        error.response.status === 403){
                        message = 'Sua sessão expirou'
                        forceLogout = true
                    } else if (error.response.data && error.response.data.message) {
                        message = error.response.data.message;
                    } else {
                        message = `Error ${error.response.status}: ${error.response.statusText}`;
                    }
                } else if (error.request) {
                    message = 'No response from the server. Please check your internet connection.';
                } else {
                    message = error.message;
                }

                toast.error(message, { autoClose: TRES_SEGUNDOS, className: 'custom-toast-error', closeButton: true });

                if (forceLogout){
                    service.logout()
                    window.location = '/'
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axios.interceptors.response.eject(axiosResponseInterceptor);
        };
    }, );

    return null;
};

export default AxiosErrorInterceptor;
